import CoapplicantSection from './CoapplicantSection';

export default CoapplicantSection;
